/**
 * Home Module Child App
 * The Home module is the default child app
 */
import { NgModule } from '@angular/core';
import { HomeRoutingModule } from "./home-routing";
import { HomeComponent } from './home.component';

// tslint:disable no-import-side-effect
import '../styles/angular-material/theming.scss?global';
import { CommonModule } from "@angular/common";
import { BtnModule } from "libraries/ui_button/btn.module";
import { CardModule } from "libraries/ui_card/card.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { HomeDomainService } from "./home-domain.service";
import { AppRootService } from "../app/shared/services/app-root/app-root-service";
import { LocalizedModule } from "libraries/pipes/localized/localized.module";
import { IconNameToDefinitionModule } from "libraries/pipes/icon-name-to-definition/icon-name-to-definition.module";

@NgModule({
    imports: [
        BtnModule,
        CardModule,
        CommonModule,
        ConfigurationResourceModule,
        FontAwesomeModule,
        HomeRoutingModule,
        IconNameToDefinitionModule,
        LocalizedModule,
    ],
    declarations: [
        HomeComponent
    ],
    bootstrap: [
        HomeComponent,
    ],
    providers: [
        HomeDomainService,
        AppRootService,
    ]
})
export class HomeModule { }
